// const cols = document.documentElement.clientWidth / 8
let data = {
    name: 'Empty',
    author: '',
    bg: '',
    layout: [],
}
export default data